<template>
  <div class="container mt-5">
    <div v-if="loading" class="text-center">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2">Loading...</p>
    </div>

    <div v-else>
      <!-- Item Summary -->
      <!-- Combined Total Item Summary & Teacher Info -->
<div class="card mb-4 shadow-sm">
  <div class="card-header bg-primary text-white">
    <h5 class="mb-0">Teacher Account & Item Summary</h5>
  </div>
  <div class="card-body">
    <div class="row">
      <!-- Total Item Summary -->
      <div class="col-md-6 border-end">
        <h6 class="text-primary mb-3">Total Item Summary</h6>
        <p><strong>Total Item Count:</strong> {{ totalItemCount }}</p>
        <p><strong>Total Subject Price:</strong> ${{ totalSubjectPrice }}</p>
        <p><strong>Total Student Level Price:</strong> ${{ totalStudentLevelPrice }}</p>
        <p class="text-success"><strong>Total Item Price:</strong> ${{ totalItemPrice }}</p>
      </div>

      <!-- Teacher Account Info -->
      <div class="col-md-6">
        <h6 class="text-secondary mb-3">Teacher Account Info</h6>
        <div v-if="error" class="text-danger">{{ error }}</div>
        <div v-else-if="!teacherAccount">
          <p class="text-muted">No account data available.</p>
        </div>
        <div v-else>
          <p><strong>User ID:</strong> {{ teacherAccount.user_id }}</p>
          <p><strong>Teacher ID:</strong> {{ teacherAccount.teacher_id }}</p>
          <p><strong>Package ID:</strong> {{ teacherAccount.package_id }}</p>
          <p><strong>Start Date:</strong> {{ teacherAccount.start_date }}</p>
          <p><strong>End Date:</strong> {{ teacherAccount.end_date }}</p>
          <p><strong>Package Type:</strong> {{ teacherAccount.package.type }}</p>
          <p><strong>Package Total Price:</strong> RS. {{ teacherAccount.pkg_total_price }}</p>
          <p><strong>Total Students:</strong> {{ teacherAccount.total_students_level }}</p>
          <p><strong>Total Subjects:</strong> {{ teacherAccount.total_subjects }}</p>
          <p><strong>Status :</strong> {{ teacherAccount.account_status.status_name }}</p>
          
          
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Combined Package Selection and Date Selection -->
<div class="card mb-4 shadow-sm">
  <div class="card-header bg-info text-white">
    <h5 class="mb-0">Select a Package and Choose Dates</h5>
  </div>
  <div class="card-body">
    <!-- Package Selection -->
    <div class="form-group mb-3">
      <label for="packageSelect" class="form-label"><strong>Choose Package:</strong></label>
      <select id="packageSelect" class="form-select" v-model="selectedPackageId">
        <option disabled value="">Please select a package</option>
        <option v-for="pkg in packages" :key="pkg.id" :value="pkg.id">
          {{ pkg.type }} = ${{ pkg.package_price }} = ${{ pkg.pkg_price_for_month }}/mo
        </option>
      </select>
    </div>

    <div class="row">
  <!-- Left Column: Package Details -->
  <div v-if="selectedPackage" class="col-md-6 bg-light p-3 rounded mb-3">
    <p><strong>Selected Package Price:</strong> RS. {{ selectedPackage.package_price }}</p>
    <p><strong>Price per Month:</strong> RS. {{ selectedPackage.pkg_price_for_month }}</p>
    <p><strong>Duration:</strong> {{ selectedPackage.duration }} Month(s)</p>
    <p class="text-success"><strong>Total Price with Items: RS. {{ selectedPackageTotalPrice }}</strong></p>
    <p class="text-success"><strong>Monthly Total with Items:</strong> RS. {{ monthlyTotalWithItems }}</p>

  </div>

  <!-- Right Column: Discount Info -->
  <!-- Right Column: Discount Info -->
<div class="col-md-6">
  <div class="card border-0 shadow-sm p-3 bg-white rounded">
    <h5 class="text-info border-bottom pb-2 mb-3">Discount Summary</h5>

    <div v-if="calculatedDiscountAmount > 0">
      <p class="mb-2">
        <strong>Discount Applied (per month):</strong>
        <span class="text-success">Rs. {{ calculatedDiscountAmount }}</span>
      </p>
      <p class="mb-2">
        <strong>Total Discount for {{ selectedPackage.duration }} months:</strong>
        <span class="text-success">Rs. {{ totalDiscountForDuration }}</span>
      </p>
      <p class="mt-3 text-success fw-bold">
        Discounted Total Price with Items: Rs. {{ discountedTotalPriceWithItems }}
      </p>
      <p class="text-success fw-bold">
        Discounted Monthly Total with Items: Rs. {{ discountedMonthlyTotalWithItems }}
      </p>
    </div>

    <div v-else class="text-muted fst-italic">
      <p>No discount is applied for this package or selection.</p>
    </div>
  </div>
</div>


</div>


    <!-- Date Selection -->
    <div class="row">
      <div class="col-md-6 mb-3">
        <label for="startDate" class="form-label"><strong>Start Date:</strong></label>
        <input
          type="date"
          id="startDate"
          v-model="start_date"
          class="form-control"
          :disabled="teacherAccount?.account_status_id != 1"
        />
      </div>

      <div class="col-md-6 mb-3">
        <label for="endDate" class="form-label"><strong>End Date:</strong></label>
        <input
          type="date"
          id="endDate"
          v-model="end_date"
          class="form-control"
          disabled
        />
      </div>
    </div>

    <!-- Submit Button and Messages -->
    <div class="col-12 mt-3 text-end">
      <button
        class="btn btn-success"
        @click="submitTeacherAcc"
        :disabled="!selectedPackage || !start_date || teacherAccount?.account_status_id != 1"
      >
        Activate Account
      </button>
    </div>
    <p><strong>Status Name:</strong> {{ accountStatus.status_name }}</p>
    <p><strong>Description:</strong> {{ accountStatus.description }}</p>

    <div v-if="successMessage" class="alert alert-success mt-2">{{ successMessage }}</div>
    <div v-if="errorMessage" class="alert alert-danger mt-2">{{ errorMessage }}</div>
  </div>
</div>

    </div>
  </div>
</template>


<script>
import axios from 'axios';

export default {
  name: 'TotalItemPrice',
  props: {
    teacherId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      totalItemCount: 0,
      totalSubjectPrice: 0,
      totalStudentLevelPrice: 0,
      totalItemPrice: 0,
      teacherAccount: null,
      packages: [],
      selectedPackageId: '',
      loading: true,
      error: null,
      start_date: this.formatDate(new Date()), // today by default
      end_date: '',
      accountStatus: {
        status_name: '',
        description: '',
      },
      successMessage: '',
errorMessage: '',

    };
  },
  computed: {
    selectedPackage() {
      return this.packages.find(pkg => pkg.id === Number(this.selectedPackageId));
    },
  //   selectedPackageTotalPrice() {
  //   if (this.selectedPackage) {
  //     return this.totalItemPrice + Number(this.selectedPackage.package_price);
  //   }
  //   return 0;
  // }
  selectedPackageTotalPrice() {
  if (this.selectedPackage) {
    const duration = Number(this.selectedPackage.duration);
    const itemPricePerMonth = this.totalItemPrice;
    const packagePrice = Number(this.selectedPackage.package_price);
    return (itemPricePerMonth * duration ) + packagePrice;
  }
  return 0;
},
monthlyTotalWithItems() {
  if (this.selectedPackage) {
    return Number(this.selectedPackage.pkg_price_for_month) + Number(this.totalItemPrice);
  }
  return 0;
},

calculatedDiscountAmount() {
  if (this.selectedPackage && this.totalItemCount > 1) {
    const itemCount = this.totalItemCount;
    const itemUnitPrice = this.totalItemPrice / itemCount;
    const remainingItems = itemCount - 1;
    let discountRate = 0;

    if (this.selectedPackage.id === 4) discountRate = 0.10;
    else if (this.selectedPackage.id === 5) discountRate = 0.20;
    else if (this.selectedPackage.id === 6) discountRate = 0.30;

    const discountAmount = itemUnitPrice * remainingItems * discountRate;
    return discountAmount.toFixed(2); // Return with 2 decimal places
  }

  return 0;
},
totalDiscountForDuration() {
  if (this.selectedPackage && this.calculatedDiscountAmount > 0) {
    return (this.calculatedDiscountAmount * this.selectedPackage.duration).toFixed(2);
  }
  return 0;
},

discountedTotalPriceWithItems() {
  if (this.selectedPackage) {
    return (this.selectedPackageTotalPrice - this.totalDiscountForDuration).toFixed(2);
  }
  return 0;
},
discountedMonthlyTotalWithItems() {
  if (this.selectedPackage) {
    return (this.monthlyTotalWithItems - this.calculatedDiscountAmount).toFixed(2);
  }
  return 0;
},

  },
  watch: {
    // selectedPackage(newVal) {
    //   if (newVal && newVal.duration) {
    //     this.calculateEndDate();
    //   }
    // },

    selectedPackage(newVal) {
    if (newVal && newVal.duration) {
      this.calculateEndDate();
    }
  },
  start_date() {
    if (this.selectedPackage?.duration) {
      this.calculateEndDate();
    }
  }
  },
  methods: {
    async fetchTotalItemSummary() {
      try {
        const response = await axios.get('/total-item-price', {
          headers: {
            'Teacher-ID': this.teacherId,
          },
        });
        const data = response.data;
        this.totalItemCount = data.total_item_count;
        this.totalSubjectPrice = data.total_subject_price;
        this.totalStudentLevelPrice = data.total_student_level_price;
        this.totalItemPrice = data.total_item_price;
      } catch (error) {
        console.error('Error fetching item summary:', error);
      }
    },
    async fetchTeacherAccount() {
      try {
        const response = await axios.get('/teacher-account', {
          headers: {
            'Teacher-ID': this.teacherId,
          },
        });
        this.teacherAccount = response.data;
        this.accountStatus = response.data.account_status;
        this.package = response.data.package;
      } catch (error) {
        console.error('Error fetching teacher account:', error);
      }
    },
    async fetchPackages() {
      try {
        const response = await axios.get('/get-all-packages');
        this.packages = response.data;
      } catch (error) {
        console.error('Error fetching packages:', error);
      }
    },
    calculateEndDate() {
      const start = new Date(this.start_date);
      const duration = this.selectedPackage?.duration || 0;
      const end = new Date(start);
      end.setMonth(end.getMonth() + duration);
      this.end_date = this.formatDate(end);
    },
    formatDate(date) {
      const d = new Date(date);
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const year = d.getFullYear();
      return `${year}-${month}-${day}`;
    },

    async submitTeacherAcc() {
  try {
    const account = {
      userId: this.teacherAccount?.user_id,
      teacherId: this.teacherAccount?.teacher_id,
      startDate: this.start_date,
      endDate: this.end_date,
      packageId: this.selectedPackageId,
      totalStudents: this.teacherAccount?.total_students_level,
      totalSubjects: this.teacherAccount?.total_subjects,
      totalPackagePrice: this.selectedPackageTotalPrice,
      discountPrice: this.totalDiscountForDuration,
    };

    const response = await axios.post('/save-or-update-acc-data', account);

    console.log('Submission successful:', response.data);
    alert(response.data.message);

    // Optional: Reset form
    // this.start_date = '';
    // this.end_date = '';
    // this.selectedPackageId = null;
    // this.selectedPackageTotalPrice = 0;

    // Fetch updated teacher account data
    this.fetchTeacherAccount();

  } catch (error) {
    if (error.response) {
      console.error('Validation or Server Error:', error.response.data.message);
      alert(error.response.data.message || 'Validation failed');
    } else {
      console.error('Unexpected Error:', error.message);
      alert('Unexpected error occurred');
    }
  }
}


  },
  mounted() {
    Promise.all([
      this.fetchTotalItemSummary(),
      this.fetchTeacherAccount(),
      this.fetchPackages(),
    ])
      .then(() => {
        if (this.teacherAccount?.package_id) {
          this.selectedPackageId = this.teacherAccount.package_id;
        }
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<style scoped lang="scss">
.container {
  max-width: 900px;
}

.card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.card-header {
  font-weight: 600;
  font-size: 1.1rem;
}

.form-label {
  font-weight: 500;
}

h6 {
  font-weight: 600;
  font-size: 1rem;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 5px;
  margin-bottom: 1rem;
}

.card .text-success {
  font-weight: 600;
}


</style>
